import ChakraMarkdown from '../../components/ChakraMarkdown';
import Seo from '../../components/Seo';
import Layout from '../../components/Layout';
import Custom404 from '../404';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_CASE_STUDY } from '../../apollo/queries/getCustomerCaseStudy';

const ClientSuccessStory = ({ slug, global }) => {
  const { data, loading, error } = useQuery(GET_CUSTOMER_CASE_STUDY, {
    context: { clientName: 'strapi' },
    variables: {
      filters: {
        url: {
          eq: slug,
        },
      },
    },
    fetchPolicy: 'cache-first',
  });

  if (!loading) {
    if (data.length === 0) {
      return <Custom404 />;
    }
  }
  return (
    <Layout global={global}>
      <Seo seo={{}} />
      {!loading && (
        <Flex direction="column" maxW={720} margin={'4rem auto'}>
          <Flex direction="column" justifyContent="center" alignItems="center">
            <Text
              my="2rem"
              textAlign="center"
              fontSize="1.6rem"
              fontWeight="600"
            >
              {data.customers.data[0].attributes.company}
            </Text>
            <Image
              src={data.customers.data[0].attributes.logo.data.attributes.url}
              width={
                data.customers.data[0].attributes.logo.data.attributes.width
              }
              height={
                data.customers.data[0].attributes.logo.data.attributes.height
              }
              alt={data.customers.data[0].attributes.company}
            />
          </Flex>
          {data.customers.data[0].attributes.caseStudy.map((item, index) => (
            <Box key={index}>
              <Text
                my="2rem"
                textAlign="center"
                fontSize="1.6rem"
                fontWeight="600"
                color="#006067"
              >
                {item.title}
              </Text>
              <ChakraMarkdown content={item.content} onLinkClick={() => null} />
            </Box>
          ))}
        </Flex>
      )}
    </Layout>
  );
};

export async function getServerSideProps({ params }) {
  return {
    props: {
      slug: params.slug,
    },
  };
}

export default ClientSuccessStory;
